<script>
import {mapState, mapActions} from 'vuex';
import ManageAllocationCalendarInfoboxPages from '../ManageAllocationCalendarInfoboxPages/ManageAllocationCalendarInfoboxPages.vue';
import moment from 'moment';

export default {
    components: {
        ManageAllocationCalendarInfoboxPages
    },
    computed: {
        ...mapState({
            showInfo: state => state.allocation.calendar.showInfo,
            infoPage: state => state.allocation.calendar.infoPage
        }),
        defaultDate: {
            get() {
                return moment().startOf('day');
            }
        }
    },
    methods: {
        ...mapActions({
            infoPageSet: 'allocation/infoPageSet',
            toggleCalendarInfoBox: 'allocation/toggleCalendarInfoBox'
        })
    }
}
</script>

<template>
    <div v-if="showInfo" :key="infoPage" class="manage-allocation-calendar-infobox">
        <div class="manage-allocation-calendar-infobox__heading">
            <div class="manage-allocation-calendar-infobox__heading">
                {{ $t('manageAllocationModalCalendarInfobox.header.heading') }}
            </div>
            <div class="manage-allocation-calendar-infobox__toggle" @click="toggleCalendarInfoBox()">
                <i class="fa fa-times-circle"/>
            </div>
        </div>
        <div class="manage-allocation-calendar-infobox__body">
            <manage-allocation-calendar-infobox-pages/>
        </div>
        <div class="manage-allocation-calendar-infobox__footer">
            <div class="manage-allocation-calendar-infobox__controls">
                <div :class="['manage-allocation-calendar-infobox__indicator', (infoPage === 1) ? 'selected' : null]" @click="infoPageSet(1)"/>
                <div :class="['manage-allocation-calendar-infobox__indicator', (infoPage === 2) ? 'selected' : null]" @click="infoPageSet(2)"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue